import React from 'react';
import audio from './AudioService';

export const SoundsContext = React.createContext(audio);
